import { withInstall } from '@antdv/utils';
import AAlert from './src/Alert';

export * from './src/props';

export const Alert = withInstall(AAlert);

export default Alert;
